import React, { useState } from 'react';

import cn from 'classnames';
import { motion } from 'framer-motion';
import DOMPurify from 'isomorphic-dompurify';

import { descriptionVariants, framerCommon, imageVariants, titleVariants } from '../../framer.variants';
import UseCaseAccordion from './accordion';
import { data_use_cases } from './content';

export default function UseCases({ id }) {
  // IMPORTANT TODO: check styles for all screen inside accordion items; do not forget about 1080x1920
  const [expanded, setExpanded] = useState(false);
  const { prefix, title, items } = data_use_cases;

  return (
    <section id={id} className="gl-wrapper gl-wrapper-y bg-black">
      <p className="gl-heading-3 text-demo-xr-blue">{prefix}</p>
      <h2 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} className="gl-heading-2 text-white" />

      <div className="mt-11 flex flex-col lg:mt-8">
        {items.map((item, idx) => (
          <div
            key={item.id}
            className={cn(
              'instance flex gap-11 overflow-hidden border-y border-y-demo-xr-blue py-9 text-white even:flex-row-reverse 1100:gap-8 lg:flex-col lg:gap-6 lg:even:flex-col sm:py-6',
              items.length > 1 && idx !== 0 && 'border-t-transparent',
            )}
          >
            <div className="flex flex-col gap-7 sm:gap-5">
              <motion.h3
                {...framerCommon}
                transition={{ duration: 1, delay: 0 }}
                variants={titleVariants}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.title) }}
                className="gl-heading-3 relative leading-[1.12] text-white lg:!transform-none"
              />
              <motion.div
                {...framerCommon}
                transition={{ duration: 1, delay: 0 }}
                variants={descriptionVariants}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.description, {ADD_ATTR: ['target']}) }}
                className="description relative lg:!transform-none [&>a]:underline"
              />
            </div>
            <div className="aspect-[518/316] min-w-[32.375rem] sm:aspect-[unset] sm:min-w-full">
              <motion.img
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 1, delay: 0 }}
                variants={imageVariants(idx % 2 === 0)}
                className="relative w-full object-cover lg:!right-0 sm:object-contain"
                src={item.image}
                alt=""
              />
            </div>
          </div>
        ))}
      </div>

      {/*      <div className="mt-11 lg:mt-8">
        {items.map((item, i) => (
          <UseCaseAccordion
            key={item.title}
            item={item}
            items={items}
            i={i}
            expanded={expanded}
            setExpanded={setExpanded}
          />
        ))}
      </div>*/}
    </section>
  );
}
